import { Icon, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaCheck, FaExclamationCircle } from "react-icons/fa";
import type { FieldStatusDto } from "../../../../../../autogen/bff-api";

interface ReadinessBadgeProps {
  status: FieldStatusDto | undefined;
}

export const ReadinessBadge = ({ status }: ReadinessBadgeProps) => {
  const { t } = useTranslation();
  if (!status) return null;
  const label = status.satisfied
    ? t("Ready to publish")
    : t("Required before publishing");
  return (
    <Tooltip label={label} placement="top">
      <span>
        <Icon
          as={status.satisfied ? FaCheck : FaExclamationCircle}
          aria-label={label}
          color={status.satisfied ? "smSuccess" : "smError"}
          boxSize="3"
          mr="1"
        />
      </span>
    </Tooltip>
  );
};
